var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"hidden-md-and-up order-info-title",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.title) + '<br />')}})}
var staticRenderFns = []

export { render, staticRenderFns }